import * as React from 'react';
import { SyntheticEvent } from 'react';
import { WatchlistItem } from 'watchlist';
import { WatchlistProps } from './WatchlistProps';
import { WatchlistView } from './WatchlistView';

interface WatchlistControllerState {
    items: WatchlistItem[]
}

export class WatchlistController extends React.Component<WatchlistProps, WatchlistControllerState> {
    constructor(props: WatchlistProps, context: any) {
        super(props, context);
        this.handleRemove = this.handleRemove.bind(this);
        this.state = {
            items: props.watchlist.getAll()
        };
    }

    public render() {
        return <WatchlistView items={this.state.items} onClickRemove={this.handleRemove}/>;
    }

    private handleRemove(item: WatchlistItem, event: SyntheticEvent) {
        event.preventDefault();

        const watchlist = this.props.watchlist;
        watchlist.remove(item);
        this.setState(() => {
            return {items: watchlist.getAll()};
        });
    }
}
